import type { GuidedView } from "../routing/guided-views.js";
import { GUIDED_VIEW_META } from "../routing/guided-views.js";

export function GuidedPageHeader({ view }: { readonly view: GuidedView }) {
  const meta = GUIDED_VIEW_META[view];
  return (
    <header className="enrein-guided-top">
      <div className="enrein-guided-version">Studio · Guided UI</div>
      <h1 id="enrein-guided-page-title">{meta.title}</h1>
      <p className="enrein-guided-subtitle">{meta.subtitle}</p>
    </header>
  );
}
